import React, { useState } from 'react';

const faqs = [
  {
    q: 'Is the assistant at the top of this page really Salesyo?',
    a: "Yes. It's not a simulation: it's our own operator, in live service, welcoming and qualifying you exactly as it would your prospects. The best way to evaluate Salesyo is to talk to it."
  },
  {
    q: 'How is Salesyo more than an AI setter?',
    a: 'A setter books a meeting, then stops. Salesyo drives the entire conversation: welcome, qualification, objections, follow-ups, and a close that fits your offer: a meeting, a direct sale, or a sign-up. It also centralizes your 10 channels into a single thread and hands over to you at the right moment.'
  },
  {
    q: "Do prospects know they're talking to an AI?",
    a: 'Salesyo writes in natural language, in your voice, with human pacing and variation. The goal is flow: a prospect who gets an immediate, relevant answer converts better. You stay in control at all times.'
  },
  {
    q: 'Is this different from a chatbot?',
    a: 'A chatbot follows a rigid decision tree: buttons, fixed scenarios, off-target answers the moment you leave the script. Salesyo understands context, handles objections with sales technique, and adapts every message. You just experienced it at the top of this page.'
  },
  {
    q: 'Which channels does it work on?',
    a: 'Instagram, WhatsApp, Messenger, LinkedIn, Gmail, Outlook, Webchat, Telegram, X and TikTok, all centralized in a single interface, with thread continuity when a prospect switches channels.'
  },
  {
    q: 'Is my data protected?',
    a: 'Salesyo is GDPR compliant, an official Meta Business Partner, and your data is hosted in the European Union.'
  }
];

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section style={{ paddingTop: 0 }}>
      <div className="wrap">
        <div className="sec-head">
          <div className="eyebrow">FAQ</div>
          <h2>Before you book your demo</h2>
        </div>
        <div className="faq">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`faq-item${openIndex === i ? ' open' : ''}`}
            >
              <div className="faq-q" onClick={() => setOpenIndex(openIndex === i ? null : i)}>
                {faq.q}<span className="pl">+</span>
              </div>
              <div className="faq-a"><div>{faq.a}</div></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQ;
